/**
 * Куда поставить выпадающий список под кнопкой.
 *
 * ═══════════════════════════════════════════════════════════════════
 * ЭТО ТРЕТЬЯ ПОПЫТКА, И ПОТОМУ ОНА ОДНА НА ВСЕХ.
 *
 * Выпадающие списки в кабинете ломались одинаково и по очереди:
 * увеличение фотографии обрезалось карточкой, окна — тоже, «Колонки»
 * в списке кампаний — сначала карточкой, потом краем экрана. Первую
 * половину болезни вылечили порталом в корень страницы. Вторая
 * половина — попадание в экран — лечилась каждый раз заново, своей
 * арифметикой на месте, и каждый раз неполно: у «Колонок» был прижат
 * правый край и забыт левый, у запросов наоборот.
 *
 * Последний случай стоил владельцу открытого списка с обрезанными
 * галочками и заголовками «АМПАНИЯ», «ТАВКИ», «АСХОД» — кнопка
 * перенеслась на вторую строку отбора к левому краю, а список
 * по-прежнему рос от неё влево.
 * ═══════════════════════════════════════════════════════════════════
 *
 * ЗДЕСЬ ТОЛЬКО СЧЁТ. Ни DOM, ни React — чтобы это можно было проверить.
 */

/** Зазор до края экрана. Впритык список читается как обрезанный. */
const EDGE = 8;

/** Ниже этой высоты список бесполезен: в него не влезет и трёх строк. */
const MIN_HEIGHT = 120;

export interface Anchor {
  left: number;
  right: number;
  bottom: number;
  top: number;
}

export interface Viewport {
  width: number;
  height: number;
}

export interface Spot {
  top: number;
  left: number;
  maxHeight: number;
}

/**
 * Положение списка под кнопкой.
 *
 * `align` — К КАКОМУ КРАЮ КНОПКИ ПРИЖАТЬСЯ, если экран позволяет.
 * Это пожелание, а не условие: попадание в экран сильнее. Кнопка
 * у правого края — список прижимается справа и растёт влево; кнопка
 * слева — наоборот.
 *
 * ШИРИНА ПРИХОДИТ ЧИСЛОМ, А НЕ МЕРЯЕТСЯ. Считать положение
 * по содержимому, которого ещё нет на экране, нельзя; мерить после
 * отрисовки — значит показать список сначала не там и дёрнуть его
 * на месте.
 *
 * СПИСОК ШИРЕ ЭКРАНА ПРИЖИМАЕТСЯ ВЛЕВО. Обрезать его придётся в любом
 * случае, но слева у списка галочки и начала слов — то, без чего он
 * нечитаем вовсе.
 */
export function placeBelow(
  anchor: Anchor,
  width: number,
  view: Viewport,
  align: 'left' | 'right' = 'right',
  /**
   * Отбивка от кнопки. Четыре — то, с чем живут меню кабинета;
   * окно периода просит шесть, потому что столько у эталона
   * (`top: calc(100% + 6px)`), и подгонять его под соседей значило бы
   * разойтись с эталоном на две точки ради единообразия, которого
   * никто не видит.
   */
  gap = 4,
): Spot {
  const wanted = align === 'right' ? anchor.right - width : anchor.left;
  const rightmost = view.width - width - EDGE;
  const left = rightmost <= EDGE ? EDGE : Math.round(Math.min(Math.max(EDGE, wanted), rightmost));

  const top = Math.round(anchor.bottom + gap);
  return {
    top,
    left,
    maxHeight: Math.max(MIN_HEIGHT, Math.round(view.height - top - EDGE * 2)),
  };
}
